export interface VolcanoStatus {
  alertLevel: 'NORMAL' | 'ADVISORY' | 'WATCH' | 'WARNING';
  aviationColorCode: 'GREEN' | 'YELLOW' | 'ORANGE' | 'RED';
  description: string;
  lastUpdate: string;
  previousStatus?: {
    alertLevel: 'NORMAL' | 'ADVISORY' | 'WATCH' | 'WARNING';
    aviationColorCode: 'GREEN' | 'YELLOW' | 'ORANGE' | 'RED';
    timestamp: string;
  };
  moreInfoUrl?: string;
}

export interface Volcano {
  id: string;
  name: string;
  location: {
    latitude: number;
    longitude: number;
    elevation?: number;
  };
  status: VolcanoStatus;
}

export const mockVolcanoes: Volcano[] = [
  {
    id: "1",
    name: "Great Sitkin",
    location: {
      latitude: 52.07639,
      longitude: -176.11083,
      elevation: 1740,
    },
    status: {
      alertLevel: "WATCH",
      aviationColorCode: "ORANGE",
      description: "Slow eruption of lava, accompanied by small earthquakes, continues.",
      lastUpdate: "2024-12-10T21:28:51Z",
      previousStatus: {
        alertLevel: "ADVISORY",
        aviationColorCode: "YELLOW",
        timestamp: "2021-07-23T22:25:55Z"
      },
      moreInfoUrl: "https://volcanoes.usgs.gov/hans2/view/notice/DOI-USGS-AVO-2024-12-10T21:26:05+00:00"
    }
  },
  {
    id: "2",
    name: "Pavlof",
    location: {
      latitude: 55.417,
      longitude: -161.887
    },
    status: {
      alertLevel: "WARNING",
      aviationColorCode: "RED",
      description: "Significant explosive eruption ongoing. Ash plume reaching 30,000 feet.",
      lastUpdate: "2024-12-10T20:15:00Z"
    }
  },
  {
    id: "3",
    name: "Cleveland",
    location: {
      latitude: 52.825,
      longitude: -169.944
    },
    status: {
      alertLevel: "ADVISORY",
      aviationColorCode: "YELLOW",
      description: "Elevated surface temperatures observed in satellite data.",
      lastUpdate: "2024-12-09T18:00:00Z"
    }
  },
  {
    id: "4",
    name: "Shishaldin",
    location: {
      latitude: 54.756,
      longitude: -163.97
    },
    status: {
      alertLevel: "NORMAL",
      aviationColorCode: "GREEN",
      description: "No unusual activity observed in satellite data.",
      lastUpdate: "2024-12-08T15:45:00Z"
    }
  }
]; 